// extracted by mini-css-extract-plugin
module.exports = {"container":"JobItemHeader__container___eRaAJ","version":"JobItemHeader__version___dUSLM","iconGit":"JobItemHeader__iconGit___+DM-K","timestamp":"JobItemHeader__timestamp___1IZcN"};